import dummyToggle from 'bloko/common/collection/dummyToggle';
/**
 * Создаёт переключатель для набора с возможностью выбора только одного элемента.
 * @returns {SetToggler}
 * @constructor
 */
function createSingleValueToggler() {
    let previousId;

    /**
     * Переключает элемент в наборе, при необходимости сбрасывая предыдущий выбранный.
     * @param {Set} set
     * @param {String} id
     * @param {Boolean} state
     * @returns {Boolean} Признак того, что переключение действительно произошло.
     */
    function toggle(set, id, state) {
        /**
         * Всего возможно 6 случаев:
         * 1. [ ].toggle(2, true)  => [2]
         * 2. [ ].toggle(2, false) => [ ]
         * 3. [1].toggle(2, true)  => [2]
         * 4. [1].toggle(2, false) => [1]
         * 5. [2].toggle(2, true)  => [2]
         * 6. [2].toggle(2, false) => [ ]
         */

        // Нет изменений (2, 4 или 5)
        if (!dummyToggle(set, id, state)) {
            return false;
        }

        // Устанавливаем новый элемент (1 или 3)
        if (state) {
            // Есть выбранный ранее элемент (3)
            if (typeof previousId !== 'undefined') {
                set.delete(previousId);
                set.add(id);
            }
            previousId = id;

            // Сбрасываем выбранный ранее элемент (6)
        } else {
            previousId = undefined;
        }

        return true;
    }

    return toggle;
}

export default createSingleValueToggler;
